import { DialPadButtonValue } from 'features/dial-pad/enums';
import type { DialPadButtonContent } from 'features/dial-pad/interfaces';

export const BaseDialPadButtonContent: Record<
  DialPadButtonValue,
  DialPadButtonContent
> = {
  [DialPadButtonValue.Zero]: { value: 0, text: '+' },
  [DialPadButtonValue.One]: { value: 1 },
  [DialPadButtonValue.Two]: { value: 2, text: 'A B C' },
  [DialPadButtonValue.Three]: { value: 3, text: 'D E F' },
  [DialPadButtonValue.Four]: { value: 4, text: 'G H I' },
  [DialPadButtonValue.Five]: { value: 5, text: 'J K L' },
  [DialPadButtonValue.Six]: { value: 6, text: 'M N O' },
  [DialPadButtonValue.Seven]: { value: 7, text: 'P Q R S' },
  [DialPadButtonValue.Eight]: { value: 8, text: 'T U V' },
  [DialPadButtonValue.Nine]: { value: 9, text: 'W X Y Z' },
  [DialPadButtonValue.Asterisk]: { value: '*' },
  [DialPadButtonValue.Hash]: { value: '#' },
};
